import { companyInfo } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20blue%20gradient%20wave%20background%2C%20smooth%20flowing%20curves%2C%20soft%20light%20effects%2C%20professional%20financial%20atmosphere%2C%20clean%20modern%20design%2C%20bright%20aesthetic&width=1600&height=600&seq=dukk-cta-bg&orientation=landscape"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-700/85" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          내 사업장에 딱 맞는 대출이 궁금하신가요?
        </h2>
        <p className="text-base md:text-lg text-white/80 font-label mb-8 max-w-2xl mx-auto">
          사업 유형과 매출을 분석하여 최적의 금리와 한도를 제안해 드립니다. 지금 바로 무료 상담을 신청하세요.
        </p>
        <button
          onClick={() => document.querySelector('#consult')?.scrollIntoView({ behavior: 'smooth' })}
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-primary-700 font-label font-semibold text-sm md:text-base hover:bg-background-50 transition-all duration-300 whitespace-nowrap"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
          {companyInfo.phone} 무료상담
        </button>
        <p className="mt-4 text-xs text-white/60 font-label">
          {companyInfo.name}는 고객님의 소중한 정보를 안전하게 보호합니다.
        </p>
      </div>
    </section>
  );
}